/** The result of an async task, whether in-progress or complete.
 *
 * This is an intentional subset of Apollo's QueryResult, to provide consistency between
 * the different kinds of async task.
 */
export interface AsyncResult<T = unknown> extends AsyncResolution<T> {
  loading: boolean;
  refetch?(): void;
}

export interface AsyncResolution<T> {
  data?: T;
  error?: unknown;
}

export const ALWAYS_LOADING = { loading: true };
